// سلّة الحذف — رسمٌ متّجه واحد لكل زرّ حذفٍ صغير (طلبات الموقع، محادثات الشات)، فلا يُرسم مرّتين.
export const TrashIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round"
    className="h-4 w-4" aria-hidden="true">
    <path d="M4 7h16M10 11v6M14 11v6M5.5 7l1 12.5a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 0 0 1.5-1.5L18.5 7M9 7V4.5h6V7" />
  </svg>
);
